import { ActionContext, ActionTree }                  from 'vuex';
import { RootState }                                  from '@/store/store.types';
import { State }                                      from '@/views/dynamic-tables/store/dynamic-tables.state.store';
import { copyTable, deleteTable, exportToExcel, getReportsList } from '@/views/dynamic-tables/service/dynamic-tables.service';
import { FileTypes }                    from '@/helpers/variables';
import { ReportsList }                                from '@/views/dynamic-tables/dynamic-tables.types';
import { Notification }                               from '@/components/notification/notification';
import i18n                                           from '@/i18n';
import { downloadFile, handleClientBasicError }       from '@/helpers/helpers';

const actions: ActionTree<State, RootState> = {
  async getDynamicTables(context: ActionContext<State, RootState>): Promise<void> {
    try {
      const { data }: { data: ReportsList[] } = await getReportsList();
      context.commit('setTableData', data);
    } catch (e) {
      throw new Error(e);
    } finally {
      context.commit('setDataLoaded', true);
    }
  },
  async deleteDynamicTable(context: ActionContext<State, RootState>, tableUuid): Promise<void> {
    context.commit('setDataLoaded', false);
    try {
      await deleteTable(tableUuid);
      await context.dispatch('getDynamicTables');

      Notification.success(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vDynamicTables.success.tableDeleted'),
      );
    } catch (e) {
      handleClientBasicError(e);
    } finally {
      context.commit('setDataLoaded', true);
    }
  },
  async copyDynamicTable(context, payload: { tableUuid: string; tableName: string }): Promise<void> {
    try {
      await copyTable(payload.tableUuid, payload.tableName);
      Notification.success(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vDynamicTables.success.tableCopied'),
      );
    } catch (e) {
      handleClientBasicError(e);
    }
  },
  async exportToExcel(context: ActionContext<State, RootState>, row: ReportsList): Promise<void> {
    try {
      const { data }: { data: Blob } = await exportToExcel(row.uuid);
      downloadFile(data, FileTypes.XLSX, row.name);
      Notification.success(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vDynamicTables.success.tableExportedToExcel'),
      );
    } catch (e) {
      handleClientBasicError(e);
    }
  },
};

export default actions;
